import React from "react";
import { blue, red, green } from "@mui/material/colors";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Chip from "@mui/material/Chip";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import moment from "moment";
require("moment/locale/th");

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontSize: 18,
    textAlign: "center",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "95%", // มือถือ
    sm: "85%", // แท็บเล็ต
    md: "70%", // เดสก์ท็อปขนาดกลาง
    lg: "60%", // เดสก์ท็อปใหญ่
  },
  maxHeight: "90vh",
  overflowY: "auto",
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: { xs: 2, sm: 3, md: 4 },
};
const theme = createTheme({
  palette: {
    primary: {
      main: red[500],
    },
    secondary: {
      main: green[500],
    },
    third: {
      main: blue[800],
    },
  },
});
function ModalTestPass({
  matchedMission,
  minscore,
  realscore,
  testconductdate,
  submittime,
  editscore,
  realscoredate,
}) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const date = moment(realscoredate).add(543, "year").format("DD MMMYY");
  const reqtime = moment(submittime, "HH:mm:ss").format("HH.mm");

  return (
    <>
      <strong>
        {matchedMission === undefined ? (
          ""
        ) : (
          <ThemeProvider theme={theme}>
            {editscore === null || editscore === 0 ? (
              realscore >= matchedMission?.matchingLevel?.minscore ||
              realscore >= matchedMission?.minscore ? (
                <Chip
                  label="ผ่าน"
                  color="secondary"
                  sx={{ fontWeight: "bold" }}
                  onClick={handleOpen}
                />
              ) : (
                <Chip
                  label="ไม่ผ่าน"
                  color="primary"
                  sx={{ fontWeight: "bold" }}
                  onClick={handleOpen}
                />
              )
            ) : editscore >= matchedMission?.matchingLevel?.minscore ||
              editscore >= matchedMission?.minscore ? (
              <Chip label="ผ่าน" color="secondary" onClick={handleOpen} />
            ) : (
              <Chip label="ไม่ผ่าน" color="primary" onClick={handleOpen} />
            )}
          </ThemeProvider>
        )}

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography
              id="modal-modal-title"
              sx={{
                textAlign: "center",
                fontWeight: "bold",
                fontSize: { xs: "22px", sm: "28px", md: "35px", lg: "35px" },
              }}
              variant="h5"
              component="h2"
            >
              ชุดข้อสอบภาษาอังกฤษ
            </Typography>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                marginTop: "10px",
              }}
            >
              <Typography
                id="modal-modal-title"
                sx={{
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "18px",
                }}
                variant="p"
                component="p"
              >
                เกณฑ์ผ่าน {minscore} คะแนน
              </Typography>
            </Box>
            <br></br>
            <TableContainer
              component={Paper}
              sx={{ overflowX: "auto", maxHeight: "300px" }}
            >
              {/* <Table sx={{ minWidth: 700 }} aria-label="customized table"> */}
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "14px",
                            sm: "14px",
                            md: "14px",
                            lg: "20px",
                          },
                          fontWeight: "bold",
                        }}
                      >
                        หัวข้อ
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell>
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "14px",
                            sm: "14px",
                            md: "14px",
                            lg: "20px",
                          },
                          fontWeight: "bold",
                        }}
                      >
                        คะแนน/100
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell>
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "14px",
                            sm: "14px",
                            md: "14px",
                            lg: "20px",
                          },
                          fontWeight: "bold",
                        }}
                      >
                        คะแนนที่ได้
                      </Typography>
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <StyledTableRow>
                    <StyledTableCell>
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "14px",
                            sm: "16px",
                            md: "18px",
                            lg: "20px",
                          },
                          textAlign: "left",
                          lineHeight: 1.6,
                          fontWeight: 400,
                        }}
                      >
                        <strong>เสร็จสิ้น</strong>
                        <br />
                        ส่งข้อสอบ วันที่ {date === "Invalid date" ? "-" : date},
                        เวลา {reqtime === "Invalid date" ? "-" : reqtime} น.
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell sx={{ textAlign: "center" }}>
                      <Typography sx={{ fontSize: "18px", fontWeight: "bold" }}>
                        100
                      </Typography>
                    </StyledTableCell>

                    {editscore === null || editscore === 0 ? (
                      <StyledTableCell sx={{ textAlign: "center" }}>
                        <Typography
                          sx={{ fontSize: "18px", fontWeight: "bold" }}
                        >
                          {realscore}
                        </Typography>
                      </StyledTableCell>
                    ) : (
                      <StyledTableCell sx={{ textAlign: "center" }}>
                        <Typography
                          sx={{ fontSize: "18px", fontWeight: "bold" }}
                        >
                          {editscore}
                        </Typography>
                      </StyledTableCell>
                    )}
                  </StyledTableRow>
                </TableBody>
              </Table>
            </TableContainer>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                marginTop: "10px",
              }}
            >
              {editscore === null || editscore === 0 ? (
                <Typography
                  id="modal-modal-title"
                  sx={{
                    textAlign: "center",
                    fontSize: {
                      xs: "16px",
                      sm: "16px",
                      md: "18px",
                      lg: "18px",
                    },
                  }}
                  variant="caption"
                  gutterBottom
                >
                  คะแนนที่ได้ คือ {realscore} คะแนน
                </Typography>
              ) : (
                <Typography
                  id="modal-modal-title"
                  sx={{
                    textAlign: "center",
                    fontSize: {
                      xs: "16px",
                      sm: "16px",
                      md: "18px",
                      lg: "18px",
                    },
                  }}
                  variant="caption"
                  gutterBottom
                >
                  คะแนนที่ได้ คือ {editscore} คะแนน
                </Typography>
              )}

              {matchedMission === undefined ? (
                ""
              ) : editscore === null || editscore === 0 ? (
                realscore >= matchedMission?.matchingLevel?.minscore ? (
                  <Typography
                    id="modal-modal-title"
                    sx={{
                      textAlign: "center",
                      color: "green",
                      fontWeight: "bold",
                      fontSize: {
                        xs: "16px",
                        sm: "16px",
                        md: "18px",
                        lg: "18px",
                      },
                    }}
                    variant="p"
                    component="p"
                  >
                    ผ่าน
                  </Typography>
                ) : (
                  <Typography
                    id="modal-modal-title"
                    sx={{
                      textAlign: "center",
                      color: "red",
                      fontWeight: "bold",
                      fontSize: {
                        xs: "16px",
                        sm: "16px",
                        md: "18px",
                        lg: "18px",
                      },
                    }}
                    variant="p"
                    component="p"
                  >
                    ไม่ผ่าน
                  </Typography>
                )
              ) : editscore >= matchedMission?.matchingLevel?.minscore ? (
                <Typography
                  id="modal-modal-title"
                  sx={{
                    textAlign: "center",
                    color: "green",
                    fontWeight: "bold",
                    fontSize: {
                      xs: "16px",
                      sm: "16px",
                      md: "18px",
                      lg: "18px",
                    },
                  }}
                  variant="p"
                  component="p"
                >
                  ผ่าน
                </Typography>
              ) : (
                <Typography
                  id="modal-modal-title"
                  sx={{
                    textAlign: "center",
                    color: "red",
                    fontWeight: "bold",
                    fontSize: {
                      xs: "16px",
                      sm: "16px",
                      md: "18px",
                      lg: "18px",
                    },
                  }}
                  variant="p"
                  component="p"
                >
                  ไม่ผ่าน
                </Typography>
              )}
            </Box>
          </Box>
        </Modal>
      </strong>
    </>
  );
}

export default ModalTestPass;
